import React from "react";
import UserList from "../../Components/UserList";

const Mentors = () => {
  return <UserList role="mentor" roleLabel="Mentors" />;
};

export default Mentors;

